<div class="animated fadeIn trafficDetail w-full h-full p-1 md:p-6" id="stuff-to-print" [reportPdfExport]="reportViewConfig">
  <ng-template dynamicComponent></ng-template>
</div>
